import * as React from "react";
import * as __intl__ from "@frameio/i18n";
import { type PressEvent } from "@frameio/vapor";
export type Text = {
    titleTransfer: string;
    titleDrive: string;
    details: (onRetry: (e: PressEvent) => void) => string | React.ReactNode;
    close: string;
};
export type Deps = {
    InlineButton: any;
};
export default {
    DEFINE(_messages: Text, { InlineButton }: Deps): void {
        return Object.defineProperties(this, {
            titleTransfer: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TransferModal.titleTransfer?c=1wtk0ui67u9nr", defaultMessage: "Launching Frame.io Transfer..." }));
                },
                enumerable: true,
                configurable: true
            },
            titleDrive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TransferModal.titleDrive?c=2s3zzot65xt90", defaultMessage: "Launching Frame.io Drive..." }));
                },
                enumerable: true,
                configurable: true
            },
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (onRetry: (e: PressEvent) => void) => __intl__.intl().formatMessage({ id: "TransferModal.details?c=2bzvkj0nv2jdd", defaultMessage: "Not opening? <InlineButton>Try again</InlineButton> or install the desktop app." }, { InlineButton: (__children__: React.ReactNode) => <InlineButton onPress={onRetry}>{React.Children.toArray(__children__)}</InlineButton> }));
                },
                enumerable: true,
                configurable: true
            },
            close: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TransferModal.close?c=1h3mba94p9xl7", defaultMessage: "Close" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
